import { defineStyleConfig } from '@chakra-ui/system';

const field = {
    width: '100%',
    height: 10,
    color: 'slt-black.900',
    borderColor: 'slt-black.900',
    borderRadius: 4,
    textStyle: 'slt-body-text',
    fontSize: '1.125rem',
    lineHeight: '1.625rem',
    paddingLeft: 2,
    _disabled: {
        color: 'slt-black.600',
        backgroundColor: 'slt-black.50',
        borderColor: 'slt-black.500',
        opacity: 1,
        _invalid: {
            borderColor: 'slt-red-error',
        },
    },
    _focus: {
        borderColor: 'slt-black.900',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.25)',
        _invalid: {
            borderColor: 'slt-red-error',
        },
    },
    _invalid: {
        borderColor: 'slt-red-error',
    },
    _hover: null,
};

const icon = {
    width: 6,
    height: 'auto',
    fontSize: '24px',
    color: 'slt-black.900',
    _disabled: {
        color: 'slt-black.600',
        opacity: 1,
    },
};

export const Select = defineStyleConfig({
    variants: {
        outline: {
            field,
            icon,
        },
    },
});
